import { connect } from 'react-redux'
import _ from 'lodash'
import Footer from './Footer'
import Header from './Header'
import styles from './index.css'
import { SilentPageProvider } from '../../../context/silentPageContext'
import PageError from '../../Common/PageError'
import { HyperLink } from '../../Common/Form'

const getSellerIdFromState = (page) => {
  const sellerIdFromState = _.get(page, 'user.sellerId', '')
  if (!sellerIdFromState) {
    return ''
  }
  return ` "${sellerIdFromState}"`
}

const Layout = (props) => {
  const { children, page, isHideUserInfo } = props
  const {
    externalSellerLoginUrl,
    errorBoundaryError
  } = page
  const { code, message: errorMessage } = errorBoundaryError || {} // redux default is null
  const isUnauthorized = code === 'UNAUTHORIZED'
  if (errorMessage) {
    return (
      <SilentPageProvider>
        <div className={styles.layout}>
          <Header />
          <main className={styles.errorLayout}>
            <PageError
              errorMessage={
                isUnauthorized ? `查無使用者${getSellerIdFromState(page)}` : errorMessage
              }
              withImage
              withErrorMessage
            >
              <HyperLink
                href={externalSellerLoginUrl}
              >
                重新登入
              </HyperLink>
            </PageError>
          </main>
          <Footer />
        </div>
      </SilentPageProvider>
    )
  }

  return (
    <div className={styles.layout}>
      <Header isHideUserInfo={isHideUserInfo} />
      <main className={styles.mainLayout}>
        {children}
      </main>
      <Footer />
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    page: state.page
  }
}

export default connect(
  mapStateToProps
)(Layout)
